import { Checkbox, TableBody, TableCell } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomHeading from '../../components/CustomHeading'
import CustomPagination from '../../components/CustomPagination'
import ConfirmDialog from '../../components/Dialog/ConfirmDialog'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useLeadTypeConversion } from '../../hooks/CompanyConfiguration/useLeadTypeConversion'

import { formatDate, handleSelectAllClick, handleSelectedItem, isSelected, paginatedData, paginatePages, ROUTES } from '../../shared/constants'
import { itemsPerPage } from '../../shared/data'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useHistory } from 'react-router'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'

function LeadTypeConversions() {
  const { leadTypeConversions } = useContext(ConfigurationContext)
  const { getAllLeadTypeConversion, deleteLeadTypeConversion, deleteManyLeadTypeConversion, BulkUpload, loading, paginate } = useLeadTypeConversion()

  const [searchQuery, setSearchQuery] = useState('')

  const filterLeadTypeConversion = leadTypeConversions
    ? leadTypeConversions.filter(
        (leadTypeConversion) =>
          (leadTypeConversion && leadTypeConversion.convertFrom && leadTypeConversion.convertFrom.name && leadTypeConversion.convertFrom.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (leadTypeConversion.convertTo && leadTypeConversion.convertTo.name && leadTypeConversion.convertTo.name.toLowerCase().includes(searchQuery.toLowerCase()))
      )
    : []
  const [page, setPage] = React.useState(1)

  const [selected, setSelected] = React.useState([])
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  // const noOfPages = paginate && paginate.totalPage
  const noOfPages = paginatePages(filterLeadTypeConversion)
  const handleChange = (event, value) => {
    setPage(value)
  }
  //console.log('SELECTED ITEM : ', selected.length > 0 && selected[0]._id)
  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const history = useHistory()

  useEffect(() => {
    getAllLeadTypeConversion({ page: page })
  }, [page])

  return (
    <Layout
      heading="Lead Type Conversion"
      url={ROUTES.ADD_LEADTYPE_CONVERSION}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      // deleteData={}
      editUrl={`/edit-leadtype-conversion/${selected.length && selected[0]._id}`}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      none
      addnone
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
    >
      <CustomTable>
        {filterLeadTypeConversion.length > 0 && (
          <CustomTableHeading
            heading={[
              <Checkbox
                indeterminate={selected.length > 0 && selected.length < filterLeadTypeConversion.length}
                checked={filterLeadTypeConversion.length > 0 && selected.length === filterLeadTypeConversion.length}
                onClick={(event) => handleSelectAllClick(event, filterLeadTypeConversion, setSelected)}
              />,
              'from',
              'duration (days)',
              'to',
              'detail',
            ]}
          />
        )}
        <TableBody>
          {!loading &&
            filterLeadTypeConversion.length > 0 &&
            paginatedData(filterLeadTypeConversion, page).map((item, index) => {
              const isItemSelected = isSelected(item, selected)
              return (
                <CustomTableRow>
                  <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
                    <Checkbox checked={isItemSelected} />
                  </TableCell>

                  <TableCell>{item.convertFrom && item.convertFrom.name}</TableCell>
                  <TableCell>{item.convertDuration + ' Days'}</TableCell>
                  <TableCell>{item.convertTo && item.convertTo.name}</TableCell>

                  <TableCell>
                    <AiOutlineInfoCircle
                      style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                      // onClick={}
                      onClick={() => history.push(`/view-leadtype-conversion/${item._id}`)}
                    />
                  </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      <ConfirmDialog
        open={deleteDialog}
        handleClose={() => setDeleteDialog(false)}
        name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteLeadTypeConversion({ convertLeadTypeId: selected[0]._id }, setSelected)}
      />
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        // name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteManyLeadTypeConversion({ convertLeadTypeId: multipleId }, setSelected)}
      />
      {!loading && filterLeadTypeConversion.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}
      {!loading && !filterLeadTypeConversion.length && <NoDataFound />}
      {loading && <Loader />}
    </Layout>
  )
}

export default LeadTypeConversions
